import { DOCUMENT, KeyValuePipe, NgClass } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';

import {
    CheckoutStorageService,
    IQuoteContextRenewal,
    OPTION_STATUS,
    Oauth2Service,
    UserOption,
} from '@bytel/checkout';

import { AppService } from '@services/app.services';
import { ConfigurationService } from '@services/configuration.service';
import { Ftth3ClicsService } from '@services/ftth3-clics.service';
import { MainCartService } from '@services/main-cart.service';

import { BasicObject } from '@interfaces/checkout.interface';

import { CookieService } from 'ngx-cookie-service';

import { DataCyDirective } from '../common/directives/data-cy.directive';
import { galliumPricesMock } from './mocks/gallium-prices';
import { MockupsConfiguratorComponent } from './mockups-configurator/mockups-configurator.component';
import { MockupsModalComponent } from './mockups-modal/mockups-modal.component';
import { MockupsProductsComponent } from './mockups-products/mockups-products.component';

interface Tab {
    label: string;
    title: string;
}

// @dynamic
@Component({
    selector: 'checkout-mocks-handler',
    templateUrl: './mocks-handler.component.html',
    styleUrl: 'mocks-handler.component.scss',
    standalone: true,
    imports: [
        NgClass,
        DataCyDirective,
        MockupsConfiguratorComponent,
        MockupsProductsComponent,
        MockupsModalComponent,
        KeyValuePipe,
    ],
})
export class MocksHandlerComponent implements OnInit {
    public tabs: BasicObject = {
        PRODUCTS: { label: 'PRODUCTS', title: 'Gestion produits' },
        STEP_MOCK_CONFIGURATOR: { label: 'STEP_MOCK_CONFIGURATOR', title: 'Mocks URL' },
        USER: { label: 'USER', title: 'Action utilisateur' },
        MODAL: { label: 'MODAL', title: 'Modal Opener' },
    };
    public currentTab: Tab = this.tabs.PRODUCTS;
    public isActive: boolean = false;
    public showMore: boolean = true;

    public constructor(
        // NOSONAR
        public appService: AppService,
        private configurationService: ConfigurationService,
        private oauthService: Oauth2Service,
        @Inject(DOCUMENT) private document: Document,
        private cookieService: CookieService,
        private checkoutStorageService: CheckoutStorageService,
        private cartService: MainCartService,
        private ftth3ClicsService: Ftth3ClicsService,
    ) {}

    public ngOnInit(): void {
        this.isActive = this.appService.debugMode.active;
        this.showMore = this.appService.debugMode.open;
        this.appService.debugSubject.subscribe((debug) => (this.isActive = debug.active));
    }

    public changeTab(key: string): void {
        const tab: Tab = this.tabs[key];
        if (tab) {
            this.currentTab = tab;
            this.showMore = true;
        }
    }

    public toggleMock(): void {
        this.isActive = !this.isActive;
        this._setDebugMode();
    }

    public toggleReveal(): void {
        this.showMore = !this.showMore;
        this._setDebugMode();
    }

    public logout(): void {
        this.oauthService.logout();
        // eslint-disable-next-line max-len
        const logoutUrl: string = this.configurationService.getData()?.oauth?.logoutUrl;
        this.document.defaultView.location.href = `${logoutUrl}?service=${window.location.href.replace(
            window.location.search,
            '',
        )}`;
    }

    public login(): void {
        const url = this.oauthService.getAuthorizeUrl();
        this.document.defaultView.location.href = url;
    }

    public changeLoading(): void {
        this.document.body.classList.toggle('is-loading');
    }

    public setFtth3Clics(): void {
        this.ftth3ClicsService.startFtth3Clics();
    }

    public setGalliumPrices(): void {
        this.checkoutStorageService.set('galliumPrices', galliumPricesMock, false);
    }

    public mockInsurance(): void {
        const context: IQuoteContextRenewal = this.cartService.cartModel
            .getQuote()
            .context.getData() as IQuoteContextRenewal;
        if (context?.options) {
            context.options.push({
                id: '11662',
                libelle: 'On sait pas mais il faut pas assurance',
                statut: OPTION_STATUS.SUBSCRIBED,
                typeOption: 'OPTION',
            } as UserOption);
        }
        this.cartService.save();
    }

    public proWall(): void {
        this.cartService.setIsFromProWall(true);
        this.cartService.refresh();
    }

    private _setDebugMode(): void {
        this.appService.setDebugMode(this.isActive, this.showMore);
    }
}
